import React, { useEffect, useState } from "react"
import { useAuth } from "../../../hooks/useAuth"
import useSpmoSummary from "./useSpmoSummary"
import { Table } from "antd"
import ColumnGroup from "antd/es/table/ColumnGroup"
import Column from "antd/es/table/Column"
import Loading from "../../../components/loading/Loading"
import { MdPending } from "react-icons/md";
import { FaCircleCheck, FaCircleMinus } from "react-icons/fa6"
import { Tooltip } from "react-tooltip"
import { useParams } from "react-router-dom"

const SPMOSummary = () => {
    const {getCurrentUser} = useAuth();
    const [isLoading, setIsLoading] = useState(false);
    const {
        summary,
        getSummary,
        phase,
        getPhase,
    } = useSpmoSummary()

    const params = useParams();

    // useEffect(() => {
    //     let user = getCurrentUser()
    //     if (user.ID && params) {
    //         getSummary(user.ID, params.project_id)
    //         getPhase(params.project_id)
    //     }
    // }, [])

    useEffect(() => {
        const loadData = async () => {
            setIsLoading(true);
            let user = getCurrentUser()
            if (user.ID && params) {
                await Promise.all([
                    getSummary(user.ID, params.project_id),
                    getPhase(params.project_id)
                ])
            }
            setIsLoading(false);
        };
    
        loadData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params]);

    return(
        <>
            <style>{`
                .spmo-summary-table .ant-table-tbody > tr:hover > td {
                    background-color: transparent !important;
                }
                .spmo-summary-table .ant-table-tbody > tr {
                    cursor: default !important;
                }
            `}</style>
            <div className="container-fluid justify-content-center" style={{ 
                margin: '0 auto',
                width: '100%',
            }}>
                <Loading state={isLoading}/>
            
            <div style={{
                backgroundColor: '#ffffff',
                borderRadius: '12px',
                padding: '24px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                border: '1px solid #f0f0f0'
            }}>
                <div className="d-flex align-items-center justify-content-between mb-3">
                    <h5 style={{ 
                        margin: 0,
                        fontWeight: 600,
                        color: '#1a1a1a',
                        fontSize: '18px'
                    }}>
                        Summary My Task (SPMO)
                    </h5>
                </div>
                
                <div className="table-responsive">
                    {
                        phase ?
                        <Table 
                            dataSource={summary}
                            scroll={{ x: 1000}} 
                            pagination={false}
                            rowKey={(record) => record.key || record.bu || `row-${record.bu}`}
                            onRow={() => ({
                                style: { cursor: 'default' }
                            })}
                            className="spmo-summary-table"
                        >
                            <Column title="BU Performance" dataIndex="bu" key="bu" fixed="left" width={"10%"}/>
                            {/* <Column title="Department" dataIndex="department" key="department" width={"7%"}/> */}
                            {
                                phase.map((p, index) => (
                                    <React.Fragment key={p.ID || index}>
                                    {
                                        index !== phase.length -1 ?
                                        <>
                                            <ColumnGroup title={
                                                <>
                                                    {`Phase ${p.Phase.Order} - ${p.Phase.Name}`} 
                                                    <br></br> 
                                                    {new Date(p.StartDate).toLocaleString('default', { day: '2-digit',  month: '2-digit', year: 'numeric' })}- 
                                                    {new Date(p.EndDate).toLocaleString('default', { day: '2-digit',  month: '2-digit', year: 'numeric' })}
                                                </>
                                            }>
                                                <Column title="PIC" dataIndex={`pic${index+1}`} key={`pic${index+1}`} width={"18%"}
                                                    render={(text, record) => (
                                                        <div className="dflex" style={{justifyContent: "center", align: "center"}}>
                                                            {
                                                                record[`pic${index+1}`] && record[`pic${index+1}`].map((data, idx) => (
                                                                    // <div 
                                                                    // style={{
                                                                    //     width: "2.5rem", 
                                                                    //     height: "3rem"
                                                                    // }}
                                                                    // >{data}</div>
                                                                    <div key={idx} style={{ height:50 }}>
                                                                        {data}
                                                                    </div>
                                                                    // {data}
                                                                ))
                                                            }
                                                        </div>
                                                    )}
                                                />
                                            </ColumnGroup>
                                        </>:
                                        <></>
                                    }
                                    </React.Fragment>
                                ))
                            }
                        </Table>:
                        <></>
                    }
                </div>
            </div>

            <Tooltip
                id="tooltip-status"
                style={{ 
                    backgroundColor: "#ffffff", 
                    color: "#1a1a1a", 
                    width: "16rem",
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                    borderRadius: '8px',
                    padding: '16px',
                    border: '1px solid #e8e8e8'
                }}
            >
                <div style={{ 
                    fontWeight: 700, 
                    marginBottom: '12px',
                    fontSize: '14px',
                    borderBottom: '2px solid #f0f0f0',
                    paddingBottom: '8px',
                    color: '#1a1a1a'
                }}>
                    SPMO Review Status
                </div>
                <div style={{ 
                    marginBottom: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    fontSize: '13px',
                    color: '#495057'
                }}>
                    <FaCircleCheck
                        color="#52c41a"
                        size={18}
                    />
                    <span>Completed</span>
                </div>
                <div style={{ 
                    marginBottom: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    fontSize: '13px',
                    color: '#495057'
                }}>
                    <MdPending
                        color="#faad14"
                        size={18}
                    />
                    <span>On Review (Pending)</span>
                </div>
                <div style={{ 
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    fontSize: '13px',
                    color: '#495057'
                }}>
                    <FaCircleMinus
                        color="#8c8c8c"
                        size={18}
                    />
                    <span>View Only</span>
                </div>
            </Tooltip>
        </div>
        </>
    )
}

export default SPMOSummary